"use strict";
// @ts-ignore
try {
    self['workbox:core:7.4.0'] && _();
}
catch (e) { }
